import { createSelector, createSlice } from "@reduxjs/toolkit";

const personSlice = createSlice({
    name: "person",
    initialState: {
        persons: [],
    },
    reducers: {
        createPerson: (state) => { },
        createdPerson: (state, action) => {
            state.persons.push(action.payload);
        },


        resetPerson: (state) => {
            state.persons = [];
        }
    }
})



export const { createPerson, createdPerson, resetPerson } = personSlice.actions;


export const personSelector = createSelector(
    state => state.persons,
    persons => persons
);


export default personSlice.reducer

